import {
  fetchAssociate,
  fetchCurrencyQuotes,
  fetchEntity,
  fetchConfig,
  fetchLocationsByRegion,
  fetchCurrencies,
} from "./api";
import {
  GETENTITY,
  LOADCONFIG,
  LOADCURRENCIES,
  LOADCURRENCYQUOTES,
  LOADLISTING,
  LOADLOCATIONS,
  SAVEHOMEPAGEFEATUREDLISTINGS,
  SAVEHEROLISTINGS,
  SAVEPRESS,
  SAVETESTIMONIALS,
  SELECTCURRENCY,
  TOGGLE_AUTH_MODAL,
  TOGGLE_FORM_TYPE,
} from "../constants/action-types";

export const getEntity = (entityId, entityType, fromPreview) => {
  return (dispatch, getState) => {
    return fetchEntity(entityId, entityType, fromPreview)
      .then((entity) => {
        dispatch({
          type: GETENTITY,
          entity: entity,
        });
      })
      .catch((error) => {
        console.error(error);
        const redirectUrl = getState().store.config.sirRootUrl;
        window.location.href = redirectUrl;
      });
  };
};

export const loadConfig = () => {
  return (dispatch) => {
    return fetchConfig()
      .then((config) => {
        dispatch({
          type: LOADCONFIG,
          config: config,
        });
      })
      .catch((error) => {
        console.error(error.response);
      });
  };
};

export const mapEntityId = (agentId, teamId, fromPreview) => {
  return (dispatch, getState) => {
    if (agentId) {
      //get associate if agent
      return fetchAssociate(agentId, fromPreview)
        .then((entity) => {
          dispatch({
            type: GETENTITY,
            entity: entity,
          });
        })
        .catch((error) => {
          console.error(error.response || error);
          const redirectUrl = getState().store.config.sirRootUrl;
          window.location.href = redirectUrl;
        });
    } else if (teamId) {
      return dispatch(getEntity(teamId, 2, fromPreview)); //entityType: Agent=1 or Team=2
    } else {
      return dispatch(getEntity());
    }
  };
};

export const loadCurrencies = () => {
  return (dispatch) => {
    return fetchCurrencies()
      .then((currencies) => {
        dispatch({
          type: LOADCURRENCIES,
          currencies: currencies,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

export const loadCurrencyQuotes = () => {
  return (dispatch) => {
    return fetchCurrencyQuotes()
      .then((currencyQuotes) => {
        dispatch({
          type: LOADCURRENCYQUOTES,
          currencyQuotes: currencyQuotes,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

export const selectCurrency = (selectedCurrency) => {
  return {
    type: SELECTCURRENCY,
    selectedCurrency,
  };
};

export const saveHeroListings = (listings) => {
  return {
    type: SAVEHEROLISTINGS,
    heroListings: listings,
  };
};

export const saveHomePageFeaturedListings = (listings) => {
  return {
    type: SAVEHOMEPAGEFEATUREDLISTINGS,
    featuredListings: listings,
  };
};

export const savePress = (press) => {
  return {
    type: SAVEPRESS,
    press: press,
  };
};

export const saveTestimonials = (testimonials) => {
  return {
    type: SAVETESTIMONIALS,
    testimonials: testimonials,
  };
};

export const loadListingDetail = (listing) => {
  return {
    type: LOADLISTING,
    listing: listing,
  };
};

export const toggleAuthModal = () => {
  return {
    type: TOGGLE_AUTH_MODAL,
  };
};

export const toggleFormType = (modalFormType) => {
  return {
    type: TOGGLE_FORM_TYPE,
    modalFormType,
  };
};

/**
 *
 * @param {Array<string>} regionUrlParts
 */
export const loadLocations = (regionUrlParts) => {
  return (dispatch) => {
    Promise.all(
      [].concat(regionUrlParts).map((region) => fetchLocationsByRegion(region))
    )
      .then((locations) => {
        dispatch({
          type: LOADLOCATIONS,
          locations,
        });
      })
      .catch((err) => console.error(err));
  };
};



// WEBPACK FOOTER //
// ./src/actions/index.js